let cartCrossSellArray = [], cartProductIdArray = [];
let cartCrossSellElem = document.querySelector('#cart-cross-sell-container');
let variantsHTML;

(function() {

  document.addEventListener('theme:cart:popdown', function(event) {
    document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
    setTimeout(function(){
      document.querySelector('[data-drawer-toggle="drawer-cart"]')?.click();
      /*setTimeout(function(){
        document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
      }, 500);*/
    }, 500);
  });

  let cartCrossSellCloseBtn = document.querySelector('.cart-cross-sell .top .close');
  if (cartCrossSellCloseBtn) {
    cartCrossSellCloseBtn.addEventListener("click", function() {
      document.querySelector('.drawer__cross-sell').style.display = 'none';
    });
  }

  document.addEventListener('theme:cart:change', function(event) {
    cartCrossSellElem.innerHTML = '';
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        cartProductIdArray = [];
        cartCrossSellArray = [];
        
        let found;
        let cartCrossSellIndex = 0;
        let cartCrossSellTotal = cart.items.length;
        
        document.querySelector('.drawer__cross-sell').style.display = 'none';
        
        cart.items.forEach(item => {
          cartProductIdArray.push(item.product_id);
          
          fetch(`/recommendations/products.json?product_id=${item.product_id}&limit=4&intent=related`)
            .then(response => response.json())
            .then(reco => {
              reco.products.forEach(recoItem => {
                cartCrossSellArray.push(recoItem);
              });

              cartCrossSellIndex++;
              if (cartCrossSellIndex >= cartCrossSellTotal) {
                const cartCrossSellArrayUnique = cartCrossSellArray.filter((obj, index, self) =>
                  index === self.findIndex((t) => t.id === obj.id)
                );
                
                let iLoop = Math.floor(cartCrossSellArrayUnique.length / 4);
                for (let i=0; i<4; i++) {
                  createProductCard(cartCrossSellArrayUnique[(iLoop * i)]);
                }
              }
              
              document.querySelector('.drawer__cross-sell').style.display = 'block';
            });
        });
      });
  });

  cartCrossSellElem.addEventListener('touchstart', function () {
    this.style.overflowX = 'hidden';
    setTimeout(() => {
      this.style.overflowX = 'scroll';
    }, 0);
  }, { passive: true });

  /*let cartCrossSellElemIsDown = false;
  let cartCrossSellElemStartX;
  let cartCrossSellElemScrollLeft;
  
  cartCrossSellElem.addEventListener("mousedown", (e) => {
    cartCrossSellElemIsDown = true;
    cartCrossSellElem.classList.add("active");
    cartCrossSellElemStartX = e.pageX - cartCrossSellElem.offsetLeft;
    cartCrossSellElemScrollLeft = cartCrossSellElem.scrollLeft;
  });
  
  cartCrossSellElem.addEventListener("mouseleave", () => {
    cartCrossSellElemIsDown = false;
    cartCrossSellElem.classList.remove("active");
  });
  
  cartCrossSellElem.addEventListener("mouseup", () => {
    cartCrossSellElemIsDown = false;
    cartCrossSellElem.classList.remove("active");
  });
  
  cartCrossSellElem.addEventListener("mousemove", (e) => {
    if (!cartCrossSellElemIsDown) return;
    e.preventDefault();
    const x = e.pageX - cartCrossSellElem.offsetLeft;
    const walk = (x - cartCrossSellElemStartX) * 2; // Multiplier pour augmenter la vitesse
    cartCrossSellElem.scrollLeft = cartCrossSellElemScrollLeft - walk;
  });*/

  /*
  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      
    }
  });
  */

  // BIS
  const btnAddToCart = document.querySelector('button[data-add-to-cart]');
  if (btnAddToCart) {
    if (btnAddToCart.disabled) BIS_trigger.style.display = 'block';
  }
  
  document.addEventListener('theme:variant:change', function(event) {
    let BIS_trigger = document.querySelector('#BIS_trigger');
    if (BIS_trigger) {
      var variant = event.detail.variant;
      if (variant) {
        if (!variant.available) BIS_trigger.style.display = 'block';
        else BIS_trigger.style.display = 'none';
      }
    }
  });
})();

function createProductCard(product) {
  const availableVariant = product.variants.find(variant => variant.available);
  if (!availableVariant) return '';

  let options = product.options;
  let optionTaillePosition = -1;
  options.forEach(option => {
    if (option.name == 'Taille') optionTaillePosition = option.position;
  });

  variantsHTML = '';
  if (optionTaillePosition > 0) {
    let container = cartCrossSellElem.querySelector('#cross-sell-' + product.handle);
    let variants = product.variants;
    
    variants.forEach(variant => {
      variantsHTML += `
        <a href="#" data-variant-id="${variant.id}" class="available-${variant.available}">${variant['option' + optionTaillePosition]}</a>
      `;
    });
  }
  
  let sHTML = `
    <div class="product-card" id="cross-sell-${product.handle}">
        <div class="product-content" data-id="${availableVariant.id}">
            <a href="${product.url}"><img src="${product.featured_image}" alt="${product.title}" class="product-image"></a>
            <div class="product-details">
                <a href="${product.url}" class="product-name">${product.title}</a>
                <p class="product-price">${(availableVariant.price / 100).toFixed(2)}€</p>
                <div class="btn-variants">${variantsHTML}</div>
            </div>
        </div>
    </div>
  `;
  cartCrossSellElem.innerHTML += sHTML;

  cartCrossSellElem.style.overflowX = 'hidden';
  setTimeout(() => {
    cartCrossSellElem.style.overflowX = 'scroll';
  }, 0);

  let cartCrossSellSubElem = document.querySelectorAll('#cart-cross-sell-container .product-card');
  if (cartCrossSellSubElem) {
    cartCrossSellSubElem.forEach(e => {
      e.addEventListener("touchmove", (ev) => {
        ev.stopPropagation();
      });
    });
  }

  let buttons = cartCrossSellElem.querySelectorAll('.btn-variants a');
  if (buttons) {
    buttons.forEach(button => {
      button.addEventListener("click", function() {
        let variantId = this.dataset.variantId;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ quantity: 1, id: variantId })
        })
        .then(response => response.json())
        .then(() => {
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
          document.dispatchEvent(new CustomEvent('theme:cart:change', {bubbles: true}));
        });
      });
    });
  }
}